import React, { useContext, useEffect, useRef, useState } from 'react'
import { Breadcrumbs, Btn, ResultsDropdown } from '../../../AbstractElements'
import CourseDropdown from "../../../Common/Component/CourseDropdown"
import { Card, CardBody, Container } from 'reactstrap'
import courseContext from '../../../Helper/Courses'
import { showAlert } from '../../../utils/alert';
import StudentContext from '../../../Helper/Students'
import { fetchCategories, userUpdate } from '../../../firebase/utils'
import { getCourseNameFromCourseId, getFullCourseName } from '../../../utils/course'
import { Table } from 'antd'
import { MoreVertical } from 'react-feather'
import { CSVLink } from 'react-csv'
import { printResultPdf } from '../../../utils/printPdf'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router'

const Result = () => {
  const [courseStudents, setCourseStudents] = useState([])
  const [mainData, setMainData] = useState([])
  const [quizzes, setQuizzes] = useState([])
  const [csvData, setCsvData] = useState([])
  let pdfData;
  const [category, setCategory] = useState({
    main: 'HTML',
    sub: 'HTML Quiz'
  })
  const csvLinkRef = useRef()
  const { activeCourse, courses, setActiveCourse } = useContext(courseContext)
  const { students, loading, setLoading, setStudents, fetchStudents } = useContext(StudentContext)
  const navigate = useNavigate();

  const deleteQuizResult = async (student) => {
    const warningText = `Are you sure you want to delete 
    ${student.fullName} ${category.main} | ${category.sub} quiz?`
    const isConfirm = await showAlert(warningText, 'Delete')
    if (isConfirm) {
      const categoryName = category.main.trim()
      const quizName = category.sub.trim()
      const filteredResult = student.result.filter(record => {
        return record.category !== categoryName && record.name !== quizName
      });
      updateState(student, filteredResult)
      await userUpdate(student.email, { result: filteredResult })
      toast.success('Result deleted sucessfully')

    }
  }

  const updateState = (student, newData) => {
    const courseState = courseStudents.map(obj => {
      if (obj.email === student.email) {
        return { ...obj, result: newData };
      };
      return obj
    })
    const csvState = csvData.map(obj => {
      if (obj.email === student.email) {
        return { ...obj, result: newData };
      };
      return obj
    })
    const mainState = mainData.map(obj => {
      if (obj.email === student.email) {
        return { ...obj, result: newData };
      };
      return obj
    })
    const studentState = students.map(obj => {
      if (obj.email === student.email) {
        return { ...obj, result: newData };
      };
      return obj
    })
    setCourseStudents(courseState)
    setCsvData(csvState)
    setMainData(mainState)
    setStudents(studentState)
  }

  const tableColumns = [
    {
      title: "Name",
      dataIndex: "fullName",
      sorter: (a, b) => a.fullName.localeCompare(b.fullName),

    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Marks",
      sorter: (a, b) => {
        const aAge = a.result[a.resultIndex]?.marks.toFixed()
        const bAge = b.result[b.resultIndex]?.marks.toFixed()
        return aAge - bAge
      },
      render: (e) => <div className='d-flex align-items-center justify-content-center'>{e?.result && e.result[e.resultIndex]?.marks.toFixed()}</div>
    },
    {
      title: "Batch",
      render: (e) => <>{getCourseNameFromCourseId(courses, e.courses[e.courseIndex].courseId)}</>
    },
    {
      title: "Action",
      render: (e) => <div className='d-flex align-items-center justify-content-center'><Btn attrBtn={{ color: "primary", onClick: () => deleteQuizResult(e) }}>Delete Quiz</Btn></div>
    },
  ]

  const downloadCsv = () => {
    csvLinkRef.current.link.click();
  }

  const downloadPdf = () => {
    printResultPdf(pdfData, category, activeCourse)
  }

  const action = [
    { key: 'CSV', label: 'Download CSV', onClick: () => downloadCsv() },
    { key: 'PDF', label: 'Download PDF', onClick: () => downloadPdf() }
  ]

  const fetchQuizzes = async () => {
    const data = await fetchCategories()
    setQuizzes(data)
  }

  const categoryClickHandler = (e, subQuiz) => {
    setCategory({
      ...category,
      main: e?.quizName ?? category.main,
      sub: subQuiz.name ?? category.sub
    })
  }

  const subCategoryClickHandler = (e, data, mainQuiz) => {
    const students = []
    let resultIndex
    const studentsData = data ?? mainData
    const quizName = e ? e.name : category.sub
    const categoryName = mainQuiz?.quizName ?? category.main;
    studentsData.forEach((student) => {
      if (student.result) {
        const currentQuiz = student?.result.find((elem, index) => {
          resultIndex = index
          return elem.name.trim() === quizName.trim() && elem.category.trim() === categoryName?.trim()
        });
        if (currentQuiz) {
          students.push({
            ...student,
            resultIndex
          })
        }
      }
    })
    const structuredData = students.map((student, index) => ({
      index: index + 1,
      fullName: student.fullName,
      email: student.email,
      marks: student.result[student.resultIndex].marks.toFixed(),
      batch: getFullCourseName(activeCourse),
    }))
    setCsvData(structuredData)
    setCourseStudents(students)
    setCategory({
      ...category,
      main: mainQuiz?.quizName ?? category.main,
      sub: e ? e.name : category.sub,
    })
  }

  const actionOptions = quizzes.map((quiz) => ({
    key: quiz.quizName,
    label: quiz.quizName,
    children: quiz.quizzes?.map((subQuiz) => ({
      key: subQuiz.name,
      label: subQuiz.name,
      onClick: () => subCategoryClickHandler(subQuiz, null, quiz),
    })),
  }));
  
  const subQuizzes = quizzes.find((quiz) => quiz.quizName === category.main)?.quizzes?.map((quiz) => ({ key: quiz.name, label: quiz.name, onClick: () => subCategoryClickHandler(quiz) }))

  const getStudents = async () => {
    setLoading(true);
    const records = [];
    if (!students.length) return
    students?.forEach((student) => {
      const selectedCourseStudents = student?.courses?.[student.courseIndex]?.courseId === activeCourse?.id;
      const courIndex = student?.courses?.findIndex(
        (cour) => cour.courseId === activeCourse?.id
      );
      if (selectedCourseStudents) {
        let studentData = { ...student, docId: student.id, courseIndex: courIndex };
        records.push(studentData);
      }
    });

    setCourseStudents(records)
    setMainData(records)
    subCategoryClickHandler(false, records)
    setLoading(false)
  };

  const courseClickHandler = (courseId) => {
    setActiveCourse(courses.find(c => c.id === courseId))
    navigate(`/results-management/${courseId}`)
  }
  useEffect(() => {
    getStudents()
  }, [students])

  useEffect(() => {
    fetchQuizzes()
    fetchStudents(activeCourse)
  }, [activeCourse])

  return (
    <>
      <Breadcrumbs mainTitle={'Result'} />
      <Container fluid={true} className="dashboard-default">
        <Card className='p-3'>
          <div className='m-t-15 m-b-15 d-flex align-items-center justify-content-center'>
            <CourseDropdown onChangeCourse={courseClickHandler} />
            <CardBody className="dropdown-basic p-4 fee-table-action d-flex align-items-center fee-table-header">
              <ResultsDropdown
                attrDropBtn={{ className: 'table-action module-btn', color: "primary" }}
                dropItem={actionOptions}
                dropBtnContent={<>{category.main ? category.main : 'Select Category'} <i className="icofont icofont-arrow-down"></i></>}
              />
              {subQuizzes?.length && <div className='m-l-20'>
                <ResultsDropdown
                  attrDropBtn={{ className: 'table-action module-btn', color: "primary" }}
                  dropItem={subQuizzes}
                  dropBtnContent={<>{category.sub ? category.sub : 'Select Sub Category'} <i className="icofont icofont-arrow-down"></i></>}
                />
              </div>}
              <div className='m-l-20'>
                <ResultsDropdown
                  attrDropBtn={{ className: 'table-action module-btn', color: "primary" }}
                  dropItem={action}
                  dropBtnContent={<>Action <i className="icofont icofont-arrow-down"></i></>}
                />
              </div>
            </CardBody>
            <CardBody className="dropdown-basic p-0 fee-table-action">
            </CardBody>
          </div>
          <div className='ant-design-table not-margin' style={{ marginBottom: '100px' }}>
            <Table
              loading={loading}
              title={(data) => {
                pdfData = data
              }}
              components={() => <h1>Hello World</h1>}
              columns={tableColumns}
              dataSource={courseStudents}
              pagination={false}
              bordered={true}
              scroll={{ x: 'auto' }}
            />
          </div>
        </Card>
        <CSVLink
          data={csvData}
          headers={[
            { label: 'NUM', key: 'index' },
            { label: 'NAME', key: 'fullName' },
            { label: 'EMAIL', key: 'email' },
            { label: 'MARKS', key: 'marks' },
            { label: 'BATCH', key: 'batch' },
            // Add more headers as needed
          ]}
          filename={`${getFullCourseName(activeCourse)}.csv`}
          ref={csvLinkRef}
          style={{ display: 'none' }}
        >
          Download CSV
        </CSVLink>
      </Container>
    </>
  )
}

export default Result